export enum InterventionEnum {
  corrective = 'corrective',
  preventive = 'preventive',
}

export enum InterventionTypeEnum {
  FIXE = 'Fixe',
  RECURRENCE = 'Recurrence',
}
